import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { Button } from '../../../../components/Button';

interface DeleteConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  serviceName: 'Slack' | 'Chatwork';
}

export default function DeleteConfirmationDialog({
  open,
  onClose,
  onConfirm,
  serviceName,
}: DeleteConfirmationDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) onClose();
      }}
    >
      <DialogContent className="w-full max-w-[600px] rounded-sm">
        <DialogTitle className="border-b border-solid border-gray-200 px-6 py-4 text-lg! font-bold!">
          通知先の連携解除
        </DialogTitle>
        <div className="p-6">
          <p>本当に{serviceName}との連携を解除しますか？</p>
        </div>
        <div className="flex justify-end gap-4 border-t border-solid border-gray-200 px-6 py-4">
          <Button color="secondary" size="md" onClick={onClose}>
            キャンセル
          </Button>
          <Button color="danger" size="md" onClick={onConfirm}>
            連携を解除する
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
